import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { RelatedEntitiesTab } from './RelatedEntitiesTab';
import ApartmentIcon from '@mui/icons-material/Apartment';
import InfoIcon from '@mui/icons-material/Info';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'resources', label: 'Resources', icon: ApartmentIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const InfrastructureEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'resources' && (
          <RelatedEntitiesTab
            relationType={RELATION_HAS_PART}
            title="Resources"
          />
        )}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
